export const booleanFromString = (v: boolean | string | number | null | undefined) =>
	v !== undefined && v !== null && ["1", "on", "true", "y", "yes", true, 1].includes(v)
